import { Component, OnInit, ViewChild, Output, ViewEncapsulation } from '@angular/core';
import { UploadXmlFileService } from '../service/upload-xml-file.service'
import { NgForm } from '@angular/forms';
import { FileUploadModule, FileUpload, MenuItem, SelectItem, ConfirmationService } from 'primeng/primeng';
import { VALID } from '@angular/forms/src/model';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { RequestOptions } from '../../../node_modules/@angular/http';
import { Observable } from "rxjs/Observable";
import { UserService } from '../shared/user.service';
import { AppSettings } from '../shared/AppSettings';
import { Form161Service } from '../service/form161.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MsvfileService } from '../service/msvfile.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-upload-xml-file',
  templateUrl: './upload-xml-file.component.html',
  styleUrls: ['./upload-xml-file.component.css'],
  providers: [ConfirmationService]
})
export class UploadXmlFileComponent implements OnInit {
  @ViewChild('fileInput') fileInput: FileUpload;
  list: any = [];
  //resultTable: FileLoadDataCompletitions[] = null;
  errors: any[] = null;
  warnings: any[] = null;
  fileId: number = null;
  dataCompletitionsErrors: any[] = null;
  //result: FileLoadDataResult = null;
  msgs: any[] = [];

  resultTable: any[] = null;
  resultTableExport: any[] = null;
  result: any = null;
  CompareData: any = null;
  //afterResultTable: any[] = null;
  //afterResult: any = null;
  resultToUser: boolean = false;
  message: boolean = false;
  overrideIfFileExist: boolean = false;
  public userDetails: any;
  fileList: FileList = null;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  cols: any[];
  colsExport: any[];  
  
  //visible: boolean = false;
  readonly rootUrl = AppSettings.webApiURL;
  tableCustomerDetail: any = { AccountNameBank: null, BankBranchName: null, BankName: '', BankNumber: '', CustomerName: '', IdentityNumber: '', CompareAllowed: false }
  listBank: any[] = [];
  listBankKolet: any[] = [];


  items: MenuItem[];
  activeIndex: number = 0;
  actionList: SelectItem[];
  actionId: number = null; //selectedActionId
  actionMasavList: SelectItem[];
  actionMasavId: number = null;
  manualFileCreatingStep: number = 0;
  fileMasavManualList: FileList = null;

  display: boolean = false;
  fileName: string = '';
  //messages: number = 2;
  listMsv: any[] = [];
  selectedMsvId: number = null;
  paramId: number = null;
  today: Date = new Date();
  alertMessage: string = '';

  showCompareDetails: boolean = false;
  compareOperation: string = null;

  showMsvEditDialog: boolean = false;


  colsCompareEmployeesNew = [
    { field: 'IdentityNumber', header: 'ת.ז.' },
    { field: 'FirstName', header: 'שם פרטי' },
    { field: 'LastName', header: 'שם משפחה' }
  ];
  colsCompareEmployeesNotReported = [
    { field: 'IdentityNumber', header: 'ת.ז.' },
    { field: 'FirstName', header: 'שם פרטי' },
    { field: 'LastName', header: 'שם משפחה' } 
  ];
  colsCompareFundsNew = [
    { field: 'MISPAR_MEZAHE_OVED', header: 'ת.ז.' },
    { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
    { field: 'SHIUR_HAFRASHA', header: 'שיעור הפרשה' }, 
    { field: 'FundName', header: 'שם קופה' }, 
    { field: 'FundType', header: 'סוג קופה' }, 
    { field: 'FundInstitutionName', header: 'קופה' }, 
    { field: 'FundIdentityNumber', header: 'ח.פ. קופה' } 
  ];
  colsCompareFundsNotReported = [
    { field: 'MISPAR_MEZAHE_OVED', header: 'ת.ז.' },
    { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
    { field: 'SHIUR_HAFRASHA', header: 'שיעור הפרשה' }, 
    { field: 'FundName', header: 'שם קופה' }, 
    { field: 'FundType', header: 'סוג קופה' }, 
    { field: 'FundInstitutionName', header: 'קופה' }, 
    { field: 'FundIdentityNumber', header: 'ח.פ. קופה' } 
  ];
  colsCompareSallary = [
    { field: 'IdentityNumber', header: 'ת.ז.' },
    { field: 'FirstName', header: 'שם פרטי' },
    { field: 'LastName', header: 'שם משפחה' },
    { field: 'SallaryMonth1', header: 'חודש שכר 1' },
    { field: 'SallaryMonth2', header: 'חודש שכר 2' },
    { field: 'SallaryMonth3', header: 'חודש שכר 3' },
    { field: 'SallaryMonth4', header: 'חודש שכר 4' },
    { field: 'Status', header: '' },
  ];
  constructor(private dataService: UploadXmlFileService, private userService: UserService, private form161Service: Form161Service, public httpClient: HttpClient, private msvService: MsvfileService, private router: ActivatedRoute, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    //debugger;
    this.paramId = Number.parseInt(this.router.snapshot.paramMap.get('id'));
    if (this.paramId !== 1 && this.paramId !== 2) {
      this.showMessage('error', '', 'שגיאה');
      return;
    }
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.form161Service.getCustomers().subscribe((result: any) => {
          this.listcustomer = result;
          this.listcustomer.unshift({ label: 'בחר מעסיק', value: null });
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
          });
      }
      else if (this.userDetails && (this.userDetails.ClientRoleCustomer || this.userDetails.ClientRoleContactMan)) {
        this.selectedCustomerId = this.userDetails.CurrentCustomerIdentityNumber;
      }
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'קיימת תקלה');
      });

    // this.cols = [
    //   { field: 'KupaName', header: 'שם הקופה' },
    //   { field: 'MisparKupaBeOtzar', header: 'מספר קופה באוצר' },
    //   { field: 'GufMosdi', header: 'ח.פ הגוף המוסדי' },
    //   { field: 'MisparBank', header: 'מספר בנק' },
    //   { field: 'ShemBank', header: 'שם הבנק' },
    //   { field: 'MisparSnifBank', header: 'מספר סניף בנק' },
    //   { field: 'MisparHeshbon', header: 'מספר חשבון' },
    //   // { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סך הפקדה' },
    //   // { field: 'MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM', header: 'אסמכתא' },
    //   // { field: 'TAARICH_ERECH_HAFKADA_LEKUPA', header: 'תאריך ערך' }
    // ];

    this.cols = [
      { field: 'KupaName', header: 'שם הקופה' },
      { field: 'MisparKupaBeOtzar', header: 'מספר קופה באוצר' },
      { field: 'GufMosdi', header: 'ח.פ הגוף המוסדי' },
      //{ field: 'MisparBank', header: 'מספר בנק' },
      { field: 'MISPAR_BANK_KOLET', header: 'מספר בנק קולט' },
      { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף קולט' },
      { field: 'MISPAR_CHESHBON_KOLET', header: 'מספר חשבון קולט' },
      { field: 'ShemBank', header: 'שם הבנק' },
      // { field: 'MisparSnifBank', header: 'מספר סניף בנק' },
      // { field: 'MisparHeshbon', header: 'מספר חשבון' },
      { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סך הפקדה' },
      { field: 'MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM', header: 'אסמכתא' },
      { field: 'TAARICH_ERECH_HAFKADA_LEKUPA', header: 'תאריך ערך' }
    ];
    this.colsExport = [
      { field: 'KupaName', header: 'שם הקופה' },
      { field: 'ShemBank', header: 'שם הבנק' },
      { field: 'MISPAR_BANK_KOLET', header: 'מספר בנק קולט' },
      { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף קולט' },
      { field: 'MISPAR_CHESHBON_KOLET', header: 'מספר חשבון קולט' },
      { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סך הפקדה (₪)' },
    ];    
    
    this.dataService.getBank().subscribe((result: any) => {
      this.listBank = result;
      this.listBank.unshift({ label: 'בחירת בנק', value: null });
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
      });

    // this.dataService.getMsvDDL().subscribe((result: any) => {
    //   this.listMsv = result;
    //   this.listMsv.unshift({ label: 'בחירת קובץ', value: null });
    // },
    //   (err: HttpErrorResponse) => {
    //     this.showMessage('error', '', 'תקלה בקבלת רשימת קבצים ');
    //   });

    this.items = [
      { label: 'בחירת קובץ' },
      { label: 'אישור נתונים' },
      { label: 'סיום' }
    ];
    this.actionList = [
      { label: 'בחירה', value: null, },
      { label: 'טעינת קובץ מהמחשב שלי', value: 1, },
      { label: 'טעינת קובץ מס"ב מרשימה', value: 2 }
    ]
    this.actionId = 1;

    this.actionMasavList = [
      { label: 'בחירה', value: null, },
      { label: 'טעינת קובץ מהמחשב שלי', value: 1, },
      { label: 'בניית קובץ ידנית', value: 2 },
      { label: 'עריכת קובץ', value: 3 }
    ]
    this.actionMasavId = 1;    
  }

  fileChange(event) {
    this.fileList = event.target.files;
    this.message = false;
    this.result = null;
    this.resultTable = null;
    this.errors = null;
    this.warnings = null;
    //this.visible = false;
    this.dataCompletitionsErrors = null;
  }

  fileUploadOperation() {
    //let fileList: FileList = event.target.files;
    this.message = false;
    this.result = null;
    this.resultTable = null;
    this.errors = null;
    this.warnings = null;
    //this.visible = false;
    this.dataCompletitionsErrors = null;
    this.tableCustomerDetail = {};

    if (this.fileList && this.fileList.length > 0) {
      let file: File = this.fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        formData.append('overrideIfFileExist', this.overrideIfFileExist ? 'true' : 'false');
        formData.append('CustomerId', this.selectedCustomerId);
      }
      else {
        formData.append('overrideIfFileExist', 'false');
        formData.append('CustomerId', '');
      }

      var reqHeader = new HttpHeaders(
        {
          //'Content-Type': 'multipart/form-data',
          'Accept': 'application/json'
        });
      this.httpClient.post(`${this.rootUrl}/api/UploadXmlFile/Upload?id=${this.paramId}&msvEdit=${this.actionMasavId}`, formData, { headers: reqHeader })
        .subscribe((response: any) => {
          // this.message = false;
          // this.result = response;
          // this.resultTable = this.result.DataCompletitions;
          // this.CompareData = this.result.CompareData;
          // this.errors = this.result.Errors;
          // this.warnings = this.result.Warnings;
          // this.dataCompletitionsErrors = this.result.DataCompletitionsErrors;
          // this.setDateFormat();
          // this.activeIndex = 1;
          // this.fileName = response.XMLFileName;
          // if (this.resultTable.length > 0) {
          //   this.getDetails();
          // }

          // if (this.result && this.result.msvEditDataJson) {
          //   // msv edit data ready
          // }

          // if (this.errors.length == 0 && this.dataCompletitionsErrors.length == 0) {
          //   this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
          //   this.setDateFormat();
          //   this.warnings = null;
          //   this.activeIndex = 1;
          //   this.alertMessage = '';
          //   this.alertMessage = 'success';

          // }

          // if (this.CompareData && this.CompareData.SallaryGaps && this.CompareData.SallaryGaps.length>0) {
          //     this.colsCompareSallary[3].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month1Title;
          //     this.colsCompareSallary[4].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month2Title;
          //     this.colsCompareSallary[5].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month3Title;
          //     this.colsCompareSallary[6].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month4Title;

          // }

          // else if (this.errors.length == 0 && ((this.resultTable.length > 0) || this.dataCompletitionsErrors.length > 0)) {
          //   this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
          //   this.resultTable = this.result.DataCompletitions;
          //   this.activeIndex = 1;
          //   this.alertMessage = '';
          //   this.alertMessage = 'error';
          // }
          // else if (this.errors.length > 0) {
          //   this.showMessage('error', '', 'שגיאה');
          //   this.activeIndex = 0;
          //   this.alertMessage = this.errors[0] ? this.errors[0] : '';
          // }

          this.treatResponse(response);

        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'קיימת תקלה. נא לוודא ששם הקובץ שנטען לא מכיל תווים אסורים. תווים מותרים הם אותיות באנגלית וספרות בלבד');
          this.activeIndex = 0;
          this.alertMessage = '';
        });
    }
    else {
      this.showMessage('error', '', 'יש לבחור קובץ');
      this.activeIndex = 0;
      this.alertMessage = '';
      //this.messages = null;
    }
  }

  treatResponse(response: any) {
      this.message = false;
      this.result = response;
      this.resultTable = this.result.DataCompletitions;
      this.CompareData = this.result.CompareData;
      this.errors = this.result.Errors;
      this.warnings = this.result.Warnings;
      this.dataCompletitionsErrors = this.result.DataCompletitionsErrors;
      this.setDateFormat();
      this.activeIndex = 1;
      this.fileName = response.XMLFileName;
      if (this.resultTable.length > 0) {
        this.getDetails();
      }

      if (this.result && this.result.msvEditDataJson) {
        // msv edit data ready
      }

      if (this.errors.length == 0 && this.dataCompletitionsErrors.length == 0) {
        this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
        this.setDateFormat();
        this.warnings = null;
        this.activeIndex = 1;
        this.alertMessage = '';
        this.alertMessage = 'success';

      }

      if (this.CompareData && this.CompareData.SallaryGaps && this.CompareData.SallaryGaps.length>0) {
          this.colsCompareSallary[3].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month1Title;
          this.colsCompareSallary[4].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month2Title;
          this.colsCompareSallary[5].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month3Title;
          this.colsCompareSallary[6].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month4Title;

      }

      else if (this.errors.length == 0 && ((this.resultTable.length > 0) || this.dataCompletitionsErrors.length > 0)) {
        this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
        this.resultTable = this.result.DataCompletitions;
        this.activeIndex = 1;
        this.alertMessage = '';
        this.alertMessage = 'error';
      }
      else if (this.errors.length > 0) {
        this.showMessage('error', '', 'שגיאה');
        this.activeIndex = 0;
        this.alertMessage = this.errors[0] ? this.errors[0] : '';
      }
  }

  onSubmit(flag: boolean, compareOperation: string): void {
    this.tableCustomerDetail = {};
    this.display = false;
    //this.visible = false;
    this.result.DataCompletitions = this.resultTable;
    this.result.Errors = this.errors;
    this.result.Warnings = this.warnings;
    this.result.DataCompletitionsErrors = this.dataCompletitionsErrors;
    this.setDateFormat();
    let compareSessionId: string = this.CompareData?this.CompareData.SessionId:null;
    if (flag) {
      let XML = this.validateForm(flag);
      if (!XML) {
        if (this.resultTable.length > 0) {
          this.getDetails();
        }
        return;
      }
      this.dataService.setDataCompletitions(flag, this.result, compareOperation, compareSessionId).subscribe((result: any) => {
        this.resultTable = result.DataCompletitions;
        this.errors = result.Errors;
        this.warnings = result.Warnings;
        this.dataCompletitionsErrors = result.DataCompletitionsErrors;
        this.fileName = result.XMLFileName;
        if (this.resultTable.length > 0) {
          // this.dataService.getCustomerDetail(this.selectedCustomerId).subscribe((result2: any) => {
          //   this.tableCustomerDetail = result2;
          // },
          //   (err: HttpErrorResponse) => {
          //     this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
          //   });
          this.getDetails();
        }


        // if (this.errors.length === 0 && this.resultTable.length === 0 && this.dataCompletitionsErrors.length === 0) {
        //   this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
        //   this.warnings = null;
        //   setTimeout(() => {
        //     location.href = 'upload-xml-file';
        //   }, 1500);
        // }

        if (this.errors.length === 0 && this.dataCompletitionsErrors.length === 0) {
          this.setDateFormat();
          this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
          this.activeIndex = 2;
          this.alertMessage = '';
          this.alertMessage = 'success';
          //this.messages = 1;
          //this.warnings = null;
          // setTimeout(() => {
          //   location.href = 'upload-xml-file';
          // }, 1500);
        }
        else if (this.errors.length === 0 && ((this.resultTable.length > 0) || this.dataCompletitionsErrors.length > 0)) {
          this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
          this.setDateFormat();
          this.activeIndex = 1;
          this.alertMessage = '';
          this.alertMessage = 'error';

        }
        else if (this.errors.length > 0) {
          this.showMessage('error', '', 'נמצאו נתונים לא תקינים');
          this.setDateFormat();
          this.activeIndex = 1;
          this.alertMessage = '';
          //this.alertMessage = 'error';
        }
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'קיימת תקלה בשמירה');
        this.activeIndex = 1;
        this.alertMessage = '';
      });
    }
    else {
      let MSV = this.validateForm(flag);
      if (!MSV) {
        if (this.resultTable.length > 0) {
          this.getDetails();
        }
        return;
      }
      this.dataService.setDataCompletitions(flag, this.result, compareOperation, compareSessionId).subscribe((result: any) => {
        this.resultTable = result.DataCompletitions;
        this.errors = result.Errors;
        this.warnings = result.Warnings;
        this.dataCompletitionsErrors = result.DataCompletitionsErrors;
        this.fileName = result.XMLFileName;
        if (this.resultTable.length > 0) {
          // this.dataService.getCustomerDetail(this.selectedCustomerId).subscribe((result2: any) => {
          //   this.tableCustomerDetail = result2;
          // },
          //   (err: HttpErrorResponse) => {
          //     this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
          //   });
          this.getDetails();
        }


        if (this.errors.length === 0 && this.dataCompletitionsErrors.length === 0) {
          //this.warnings = null;
          this.setDateFormat();
          if (result.MSVFileName && result.FileId && result.FileId > 0) {
            this.downloadFile(result.MSVFileName, result.FileId);
          }

          this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
          this.activeIndex = 2;
          this.alertMessage = '';
          this.alertMessage = 'success';
          //this.messages = 1;

          // setTimeout(() => {
          //   location.href = 'upload-xml-file';
          // }, 1500);
        }


        else if (this.errors.length === 0 && ((this.resultTable.length > 0) || this.dataCompletitionsErrors.length > 0)) {
          this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
          this.setDateFormat();
          this.activeIndex = 1;
          this.alertMessage = '';
          this.alertMessage = 'error';
        }
        else if (this.errors.length > 0) {
          this.showMessage('error', '', 'נמצאו נתונים לא תקינים');
          this.setDateFormat();
          this.activeIndex = 1;
          this.alertMessage = '';
          //this.alertMessage = 'error';
        }
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'קיימת תקלה בשמירה');
        this.activeIndex = 1;
        this.alertMessage = '';
      });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });   //type='success'/'error'/'warn'/'success'
  }

  copyingRecords(num: number): void {
    if (num > 0 && num !== null) {
      if (num === 1) {
        let cntA = 0;
        let cntB = 0;
        let date: Date = new Date();
        for (let i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[0].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM) {
            if (this.resultTable[i].SACH_HAFKADA_KUPA_H_P && this.resultTable[i].SACH_HAFKADA_KUPA_H_P != 0) {
              this.resultTable[i].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM = this.resultTable[0].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM;
              cntA++;              
            }

          }
          if (this.resultTable[0].TAARICH_ERECH_HAFKADA_LEKUPA) {
            date = new Date(Date.parse(this.resultTable[0].TAARICH_ERECH_HAFKADA_LEKUPA));
            this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA_Formatted = date.toDateString();
            this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 22, 0, 0);
            cntB++;
          }
        }
        if (cntA === this.resultTable.length && cntB === this.resultTable.length) {
          this.showMessage('success', '', 'בוצע הזנה של אסמכתא ותאריך ערך לכל הרשומות');
        }
        else if ((cntA > 0) || (cntB > 0)) {
          this.showMessage('warn', '', 'בוצע הזנה חלקית');
        }
        else if (cntA === 0 && cntB === 0) {
          this.showMessage('error', '', 'שגיאה בהזנת אסמכתא ותאריך ערך');
        }
        else {
          this.showMessage('error', '', 'שגיאה בהזנת אסמכתא ותאריך ערך');
        }
      }
      else if (num === 2) {
        let cnt_SNIF_MAASIK = 0;
        let cnt_BANK_MAASIK = 0;
        let cnt_CHESHBON_MAASIK = 0;
        for (let i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[0].MISPAR_SNIF_MAASIK) {
            this.resultTable[i].MISPAR_SNIF_MAASIK = this.resultTable[0].MISPAR_SNIF_MAASIK;
            cnt_SNIF_MAASIK++
          }
          if (this.resultTable[0].MISPAR_BANK_MAASIK) {
            this.resultTable[i].MISPAR_BANK_MAASIK = this.resultTable[0].MISPAR_BANK_MAASIK;
            cnt_BANK_MAASIK++
          }
          if (this.resultTable[0].MISPAR_CHESHBON_MAASIK) {
            this.resultTable[i].MISPAR_CHESHBON_MAASIK = this.resultTable[0].MISPAR_CHESHBON_MAASIK;
            cnt_CHESHBON_MAASIK++
          }
        }
        if (cnt_SNIF_MAASIK === this.resultTable.length && cnt_BANK_MAASIK === this.resultTable.length && cnt_CHESHBON_MAASIK === this.resultTable.length) {
          this.showMessage('success', '', 'בוצע הזנה של חשבון מעסיק לכל הרשומות');
        }
        else if ((cnt_SNIF_MAASIK > 0) || (cnt_BANK_MAASIK > 0) || (cnt_CHESHBON_MAASIK > 0)) {
          this.showMessage('warn', '', 'בוצע הזנה חלקית');
        }
        else if (cnt_SNIF_MAASIK === 0 && cnt_BANK_MAASIK === 0 && cnt_CHESHBON_MAASIK === 0) {
          this.showMessage('error', '', 'שגיאה בהזנת חשבון מעסיק');
        }
        else {
          this.showMessage('error', '', 'שגיאה בהזנת חשבון מעסיק');
        }
      }
      else if (num === 3) {
        let cnt_title_SNIF_MAASIK = 0;
        let cnt_title_BANK_MAASIK = 0;
        let cnt_title_CHESHBON_MAASIKK = 0;
        for (let i = 0; i < this.resultTable.length; i++) {
          if (this.tableCustomerDetail.BankBranchName) {
            this.resultTable[i].MISPAR_SNIF_MAASIK = this.tableCustomerDetail.BankBranchName;
            cnt_title_SNIF_MAASIK++;
          }
          if (this.tableCustomerDetail.BankNumber) {
            this.resultTable[i].MISPAR_BANK_MAASIK = this.tableCustomerDetail.BankNumber;
            cnt_title_BANK_MAASIK++;
          }
          if (this.tableCustomerDetail.AccountNameBank) {
            this.resultTable[i].MISPAR_CHESHBON_MAASIK = this.tableCustomerDetail.AccountNameBank;
            cnt_title_CHESHBON_MAASIKK++;
          }
        }
        if (cnt_title_SNIF_MAASIK === this.resultTable.length && cnt_title_BANK_MAASIK === this.resultTable.length && cnt_title_CHESHBON_MAASIKK === this.resultTable.length) {
          this.showMessage('success', '', 'בוצע הזנה של פרטי כותרת לכל הרשומות');
        }
        else if ((cnt_title_SNIF_MAASIK > 0) || (cnt_title_BANK_MAASIK > 0) || (cnt_title_CHESHBON_MAASIKK > 0)) {
          this.showMessage('warn', '', 'בוצע הזנה חלקית');
        }
        else if (cnt_title_SNIF_MAASIK === 0 && cnt_title_BANK_MAASIK === 0 && cnt_title_CHESHBON_MAASIKK === 0) {
          this.showMessage('error', '', 'שגיאה בהזנת פרטי כותרת');
        }
        else {
          this.showMessage('error', '', 'שגיאה בהזנת פרטי כותרת');
        }
      }
      else {
        this.showMessage('error', '', 'שגיאה.');
      }
    }
    else {
      this.showMessage('error', '', 'שגיאה.');
    }
  }

  reload(): void {
    let c = confirm('האם ברוצנך לבטל את התהליך?');
    if (c) {
      this.showMessage('success', '', 'העמוד נטען מחדש');
      setTimeout(() => {
        location.href = `upload-xml-file/${this.paramId}`;
      }, 1500);
    }
  }

  setDateFormat(): void {
    let date: Date = new Date();
    for (let i = 0; i < this.resultTable.length; i++) {
      if (this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA != null || this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA != undefined) {
        date = new Date(Date.parse(this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA));
        this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA_Formatted = date.toDateString();
        this.resultTable[i].TAARICH_ERECH_HAFKADA_LEKUPA = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 22, 0, 0);
      }
    }
  }

  copyText(val: string) {
    if (val == null) { val = ""; }
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  downloadFile(fileName: string, fileId: number): void {
    if (fileName && fileId && fileId > 0) {
      try {
        this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        let customerId: string = '';
        customerId = this.selectedCustomerId ? this.selectedCustomerId : '';
        this.dataService.getDownloadFile(fileName, fileId, customerId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
          setTimeout(() => {
            this.showMessage('success', '', 'הקובץ נשמר בהצלחה');
          }, 1500);
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'תקלה בהכנת הורדת הקובץ');
    }
  }

  // validateForm(flag: boolean): boolean {
  //   let validation: boolean = false;
  //   if (flag) { // XML
  //     for (const iterator of this.resultTable) {
  //       if (iterator.MISPAR_BANK_MAASIK && (iterator.MISPAR_SNIF_MAASIK) &&
  //         (iterator.MISPAR_CHESHBON_MAASIK) && (iterator.MISPAR_BANK_KOLET) &&
  //         (iterator.MISPAR_SNIF_KOLET) && (iterator.MISPAR_CHESHBON_KOLET) &&
  //         (iterator.SACH_HAFKADA_KUPA_H_P) && (iterator.TAARICH_ERECH_HAFKADA_LEKUPA)) {
  //         validation = true;
  //       }
  //       else {
  //         validation = false;
  //         break;
  //       }
  //     }
  //   } else {
  //     for (const iterator of this.resultTable) {
  //       if ((iterator.SACH_HAFKADA_KUPA_H_P)) {
  //         validation = true;
  //       }
  //       else {
  //         validation = false;
  //         break;
  //       }
  //     }
  //   }
  //   return validation;
  // }

  // validateForm(flag: boolean): boolean {
  //   let validation: boolean = false;
  //   if (flag) { // XML
  //     for (const iterator of this.resultTable) {
  //       if (iterator.MISPAR_BANK_MAASIK && (iterator.MISPAR_SNIF_MAASIK) &&
  //         (iterator.MISPAR_CHESHBON_MAASIK) && (iterator.MISPAR_BANK_KOLET) &&
  //         (iterator.MISPAR_SNIF_KOLET) && (iterator.MISPAR_CHESHBON_KOLET) &&
  //         (iterator.SACH_HAFKADA_KUPA_H_P) && (iterator.TAARICH_ERECH_HAFKADA_LEKUPA)) {
  //         validation = true;
  //       }
  //       else {
  //         validation = false;
  //         break;
  //       }
  //     }
  //   } else {
  //     for (const iterator of this.resultTable) {
  //       if ((iterator.SACH_HAFKADA_KUPA_H_P)) {
  //         validation = true;
  //       }
  //       else {
  //         validation = false;
  //         break;
  //       }
  //     }
  //   }
  //   return validation;
  // }

  validateForm(flag: boolean): boolean {
    let validation: boolean = false;
    if (flag) { // XML
      for (const iterator of this.resultTable) {
        if (iterator.KOD_EMTZAI_TASHLUM && iterator.KOD_EMTZAI_TASHLUM !== '5') {
          if ((iterator.MISPAR_BANK_MAASIK) && (iterator.MISPAR_SNIF_MAASIK) &&
            (iterator.MISPAR_CHESHBON_MAASIK) && (iterator.MISPAR_BANK_KOLET) &&
            (iterator.MISPAR_SNIF_KOLET) && (iterator.MISPAR_CHESHBON_KOLET) &&
            (iterator.SACH_HAFKADA_KUPA_H_P >=0) && (iterator.TAARICH_ERECH_HAFKADA_LEKUPA)) {
            validation = true;
          }
          else {
            validation = false;
            this.showMessage('error', '', 'נא למלא בנק מעסיק, סניף מעסיק, חשבון מעסיק, בנק קולט, מס סניף קולט, מס חשבון קולט, סך הפקדה ותאריך ערך');
            break;
          }
        }
        else {
          if ((iterator.SACH_HAFKADA_KUPA_H_P >=0) && (iterator.TAARICH_ERECH_HAFKADA_LEKUPA)) {
            validation = true;
          }
          else {
            validation = false;
            this.showMessage('error', '', 'חובה למלא ערך חיובי בסך הפקדה ותאריך ערך');
            break;
          }
        }
      }
    } else {
      for (const iterator of this.resultTable) {
        if ((iterator.SACH_HAFKADA_KUPA_H_P >=0)) {
          validation = true;
        }
        else {
          validation = false;
          this.showMessage('error', '', 'נא למלא ערך חיובי בסך הפקדה');
          break;
        }
      }
    }
    return validation;
  }

  getDetails(): void {
    if (this.selectedCustomerId && this.resultTable.length > 0) {
      this.dataService.getCustomerDetail(this.selectedCustomerId).subscribe((result2: any) => {
        this.tableCustomerDetail = result2;

        if (this.tableCustomerDetail.BankNumber && !this.tableCustomerDetail.isMasavExportExcelShortFormatBanks) {
            let f = this.colsExport.find(f => f.field == 'MisparKupaBeOtzar');
            if (!f) {
              this.colsExport.push({ field: 'MisparKupaBeOtzar', header: 'מספר קופה באוצר' });
            }
            let f1 = this.colsExport.find(f => f.field == 'GufMosdi');
            if (!f1) {
              this.colsExport.push({ field: 'GufMosdi', header: 'ח.פ הגוף המוסדי' });
            }
        }

      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
        this.tableCustomerDetail = {};
      });
    }
  }
  firstStep(): void {
    if (this.activeIndex !== null && this.activeIndex !== undefined) {
      if (this.activeIndex === 0 && this.actionId === 1) {
        this.fileUploadOperation();
      }
    }
  }

  showDialog(operation: string): void {
    this.compareOperation = operation;
    this.display = true;
  }

  closeDialog() {
    this.display=false;
    this.compareOperation = null;
  }

  onChangeMsv(id: number): void {
    if (id) {
      this.msvService.prepareData(id).subscribe((result: any) => {
        this.result = result
        this.resultTable = result.DataCompletitions;
        this.errors = result.Errors;
        this.warnings = result.Warnings;
        this.dataCompletitionsErrors = result.DataCompletitionsErrors;
        this.fileName = result.XMLFileName;
        if (this.resultTable.length > 0) {
          this.activeIndex = 1;
          this.getDetails();
          this.setDateFormat();
        }
      }, (error: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת נתונים להשלמה');
        this.activeIndex = 0;
      });
    }
    else {
      this.showMessage('error', '', 'תקלה בקבלת נתונים להשלמה');
      this.activeIndex = null;
    }
  }
  
  onChangeMsvDDL(): void {
    if (this.actionId === 2) {
      if (this.selectedCustomerId) {
        this.dataService.getMsvDDL(this.selectedCustomerId).subscribe((result: any) => {
          this.listMsv = result;
          this.listMsv.unshift({ label: 'בחירת קובץ', value: null });
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
          });
      } else {
        this.listMsv = null;
        this.listMsv.unshift({ label: 'בחירת קובץ', value: null });
      }
    }
  }



  getCompareCounts() {
    if (this.CompareData) {
      let c = 0;
      c+= this.CompareData.EmployeesNew?isNaN(this.CompareData.EmployeesNew.length)?0:this.CompareData.EmployeesNew.length:0;
      c+= this.CompareData.EmployeesNotReported?isNaN(this.CompareData.EmployeesNotReported.length)?0:this.CompareData.EmployeesNotReported.length:0;
      c+= this.CompareData.FundsNew?isNaN(this.CompareData.FundsNew.length)?0:this.CompareData.FundsNew.length:0;
      c+= this.CompareData.FundsNotReported?isNaN(this.CompareData.FundsNotReported.length)?0:this.CompareData.FundsNotReported.length:0;
      c+= this.CompareData.SallaryGaps?isNaN(this.CompareData.SallaryGaps.length)?0:this.CompareData.SallaryGaps.length:0;
      //c+= (this.CompareData.SallaryValid && this.CompareData.SallaryValid == 2)?1:0;
      return c;
    } else {
      return 0;
    }
  }

  ShowCompareDetails() {
    this.showCompareDetails = true;
  }

  markToDelete(rowData) {
    this.confirmationService.confirm({
      message: 'האם ברצונך למחוק את הקופה מהקובץ עם כל העובדים שבה?',
      accept: () => {
          rowData.MarkedForDeletition = true;
      },
      reject: () => {
        
      }
    }); 

  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  exportToExcel(dtExport: any) {
    this.resultTableExport = this.resultTable.filter(f=>!f.MarkedForDeletition);
    dtExport.exportCSV()
  }


  onChangeActionsMsvDDL() {
    this.manualFileCreatingStep = 0;
  }

  onChangeMasavManualExcelDownload() {
    let customerId: string = '';
    customerId = this.selectedCustomerId ? this.selectedCustomerId : '';
    if (!customerId) {
      this.showMessage('error', '', 'נא לבחור מעסיק');
      return;
    }
    try {
        this.showMessage('info', '', 'הקובץ תבנית יהיה מוכן בעוד מספר שניות');
        
        let fileName = customerId + '.' + (new Date()).getFullYear().toString() + '.' + ((new Date().getMonth()+1)).toString().padStart(2, '0') + '.' + (new Date()).getDate().toString().padStart(2, '0') + '.xlsx';
        
        this.dataService.getManualMasavDownloadFile(customerId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();

          setTimeout(() => {
            this.manualFileCreatingStep = 1;
          }, 1000);

        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ תבנית');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ תבנית');
      }

    
  }

  onChangeMasavManualFileSelected(event) {
    this.fileMasavManualList = event.target.files;
  }

  masavManualFileSelectedUploadOperation() {
    //let fileList: FileList = event.target.files;
    this.message = false;
    this.result = null;
    this.resultTable = null;
    this.errors = null;
    this.warnings = null;
    //this.visible = false;
    this.dataCompletitionsErrors = null;
    this.tableCustomerDetail = {};

    if (this.fileMasavManualList && this.fileMasavManualList.length > 0) {
      let file: File = this.fileMasavManualList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        formData.append('overrideIfFileExist', this.overrideIfFileExist ? 'true' : 'false');
        formData.append('CustomerId', this.selectedCustomerId);
      }
      else {
        formData.append('overrideIfFileExist', 'false');
        formData.append('CustomerId', '');
      }

      var reqHeader = new HttpHeaders(
        {
          //'Content-Type': 'multipart/form-data',
          'Accept': 'application/json'
        });
      this.httpClient.post(`${this.rootUrl}/api/MSVFileAPI/UploadMasavFilledTemplateFile`, formData, { headers: reqHeader })
        .subscribe((response: any) => {
          
          // next whole block copied from fileUploadOperation(), after ".subscribe((response: any) "
          this.message = false;
          this.result = response;
          this.resultTable = this.result.DataCompletitions;
          this.CompareData = this.result.CompareData;
          this.errors = this.result.Errors;
          this.warnings = this.result.Warnings;
          this.dataCompletitionsErrors = this.result.DataCompletitionsErrors;
          this.setDateFormat();
          this.activeIndex = 1;
          this.fileName = response.XMLFileName;
          if (this.resultTable.length > 0) {
            this.getDetails();
          }


          if (this.errors.length == 0 && this.dataCompletitionsErrors.length == 0) {
            this.showMessage('success', '', 'הקובץ נבדק ונמצא תקין לשידור למסלקה');
            this.setDateFormat();
            this.warnings = null;
            this.activeIndex = 1;
            this.alertMessage = '';
            this.alertMessage = 'success';
          }

          if (this.CompareData && this.CompareData.SallaryGaps && this.CompareData.SallaryGaps.length>0) {
              this.colsCompareSallary[3].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month1Title;
              this.colsCompareSallary[4].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month2Title;
              this.colsCompareSallary[5].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month3Title;
              this.colsCompareSallary[6].header = 'שכר ' + this.CompareData.SallaryGaps[0].Month4Title;
          }

          else if (this.errors.length == 0 && ((this.resultTable.length > 0) || this.dataCompletitionsErrors.length > 0)) {
            this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
            this.resultTable = this.result.DataCompletitions;
            this.activeIndex = 1;
            this.alertMessage = '';
            this.alertMessage = 'error';
          }
          else if (this.errors.length > 0) {
            this.showMessage('error', '', 'שגיאה');
            this.activeIndex = 0;
            this.alertMessage = this.errors[0] ? this.errors[0] : '';
          }
          // end whole block copied from fileUploadOperation()

        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'קיימת תקלה. נא לוודא ששם הקובץ שנטען לא מכיל תווים אסורים. תווים מותרים הם אותיות באנגלית וספרות בלבד');
          this.alertMessage = '';
        });
    }
    else {
      this.showMessage('error', '', 'יש לבחור קובץ');
      this.alertMessage = '';
    }
  }


  showMsfEdit() {
    this.showMsvEditDialog = true;
  }

  onSaveMsvFinished(event: any) {
    this.showMsvEditDialog = false;
    this.treatResponse(event);
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/upload-xml-file/upload-xml-file.component.ts